var map = {
	"./baseballCap.svg": 2327,
	"./beretHat.svg": 8851,
	"./bobbleHat.svg": 1891,
	"./bucketHat.svg": 5886,
	"./cowboyHat.svg": 4876,
	"./farmHat.svg": 41,
	"./flowerHat.svg": 2022,
	"./gradHat.svg": 3374,
	"./heliHat.svg": 6463,
	"./miladyHat.svg": 2413,
	"./mushHat.svg": 5524,
	"./snapHat.svg": 5018,
	"./sombHat.svg": 2751,
	"./sunHat.svg": 1753,
	"./topHat.svg": 3501,
	"./vikingHat.svg": 3855,
	"./wizardHat.svg": 9282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;